<div
    class="math-container"
    [class.is-inline-alignment]="isInline"
    [class.is-heading]="isHeading()"
    [class.is-heading-small]="isHeadingSmall()"
    [class.is-body]="isBody()"
    [class.is-small]="isSmall()"
>
    <render-math [obj]="element" [prop]="'latex'"></render-math>
</div>
